import React from 'react';
import { Content, Box } from 'reactjs-admin-lte';
import Pagination from 'components/core/Pagination';
import ClientListFilter from './ClientListFilter';
import ClientListTable from './ClientListTable';


const ClientList = (props) => {

  const {
    clients,
    pageSize,
    currentPage,
    isLoading,
    keyword,
    handleKeywordChange,
    handleSubmit,
    handleTabOpen,
    handlePageSelect
  } = props;

  return (
    <Content.Body>
      <ClientListFilter
        keyword={keyword}
        handleKeywordChange={handleKeywordChange}
        handleSubmit={handleSubmit} />
      <Box
        className="box-widget mb-0"
        loading={isLoading}>
        <Box.Body noPadding={true}>
          <ClientListTable
            clients={clients}
            handleTabOpen={handleTabOpen} />
        </Box.Body>
        <Box.Footer>
          <Pagination
            currentPage={currentPage}
            totalPages={pageSize}
            onChange={handlePageSelect} />
        </Box.Footer>
      </Box>
    </Content.Body>
  )
}

export default ClientList;